import React,{useEffect, useState} from 'react'
import Boardcard from '../../Components/Boardcard/Boardcard'
import ButtonPagenate from '../../Components/ButtonPagenate/ButtonPagenate'
import Navbar from '../../Components/Navbar/navbar'
import Topbarsub from '../../Components/Topbar/Topbarsub'
import AppraisalList from './appraisaList'
import './Treatedappraisal.css'

const Treatedappraisal = ({page, urole}) => {
  const [searchcriteria, setSearchcriteria] = useState("")
  const [appraisal, setAppraisal] = useState(AppraisalList)
  const [nameSearch, setNameSearch] = useState("")
  
  const [pageNumber, setPageNumber] = useState(0);
//   const [loading, setLoading] = useState(true)
//   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 8; //Number of items to be displayed per page 
  const pageCount = Math.ceil(appraisal.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;
//   const API = 'https://admin.sabrecwa.com/backend'

    const handleSearchCriteria = (incoming) =>{
      setSearchcriteria(incoming)
    }

    useEffect(() => {
      // 👇️ scroll to top on page load
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, []);

    const handleAddNewEmp = () =>{

    }

    const filterSearch = (incoming) =>{
        setNameSearch(incoming.toString())
    }

    var appraisalLists = appraisal.filter((filteredItem) => {
        if (searchcriteria === "" && nameSearch === "") {
          return filteredItem;
        } else if (searchcriteria !== "" && nameSearch === "") {
          return filteredItem;
        } else if (searchcriteria === "" && nameSearch !== "") {
          return filteredItem;
        } else if (searchcriteria !== "" && nameSearch !== "") {
          if(searchcriteria === "Fullname"){
            if (filteredItem.firstname.toLowerCase().includes(nameSearch.toLowerCase())) {
              return filteredItem;
            }
          } else if(searchcriteria === "Designation"){
            if (filteredItem.designation.toLowerCase().includes(nameSearch.toLowerCase())) {
              return filteredItem;
            }
          } else if(searchcriteria === "Department"){
            if (filteredItem.department.toLowerCase().includes(nameSearch.toLowerCase())) {
              return filteredItem;
            }
          } else if(searchcriteria === "Status"){
            if (filteredItem.status.toString().includes(nameSearch)) {
              return filteredItem;
            }
          } else {
            return filteredItem;
          }
        }
    });

    const newPagenum = (num) =>{
        setPageNumber(num)
    }

    const handleView = (incoming) =>{
        // console.log(incoming)
        // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
    }

  return (
    <div className='treated-appraisal-container'>
        <Navbar tabtext="Treated Appraisals" currentab='others'/>
        <Topbarsub role={urole.role} serchCriteria={handleSearchCriteria} newEmployee={handleAddNewEmp} currrenTab={page} searchword={filterSearch}/>
        <div className='tretapp-card-container'>
            <Boardcard val={120} name="Submitted Appraisals" maxV={500} minV={0}/>
            <Boardcard val={220} name="Unsubmitted Appraisals" maxV={500} minV={0}/>
        </div>

        <div className='tretapp-list-submitted'>
            <div className='tapp-list-title-container'>
                <span id='tapp-list-title'>Appraisal List</span>
            </div>
            <div className='comp-list-table-containerr'>
                <table>
                    <thead>
                        <tr>
                            <th scope="col">EmpID</th>
                            <th scope="col">Fullname</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Department</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {appraisalLists.reverse().slice(pagesVisited, pagesVisited + itemsPerpage).map((items) =>(
                            <tr>
                                <td data-label="EmpID">{items.empid}</td>
                                <td data-label="Fullname">{items.lastname + ' ' + items.firstname}</td>
                                <td data-label="Designation">{items.designation}</td>
                                <td data-label="Department">{items.department}</td>
                                <td data-label="Status">{items.status === 1 ? <div onClick={() => handleView(items.empid)} className='butn-status submitted'>Submitted</div>:<div onClick={() => handleView(items.empid)}  className='butn-status pending'>Pending</div>}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className='papp-table-pgnate-contain'>
                    <ButtonPagenate 
                    updatedPageNum={newPagenum}
                    pageCount={pageCount}
                    pageNumber={pageNumber}
                    previousLabel="Prev"
                    nextLabel="Next"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Treatedappraisal